const portfolio = [
{"image":"//azabache-producciones.com/cdn/shop/t/6/assets/az-0eb25c21-portfolio-work-coffee.webp?v=182281037043157524521791515449","thumb":"//azabache-producciones.com/cdn/shop/t/6/assets/az-222b4f90-portfolio-work-coffee-thumb.webp?v=31673880598507969961791515462","title":"Work Coffee","caption":"Identidad visual · Cafetería","alt":"Work Coffee · Identidad visual · Cafetería","width":1600,"height":900,"contain":true},
{"image":"//azabache-producciones.com/cdn/shop/t/6/assets/az-5079a93c-portfolio-identidad-musical.webp?v=28966856774393766711791515500","thumb":"//azabache-producciones.com/cdn/shop/t/6/assets/az-f194eac3-portfolio-identidad-musical-thumb.webp?v=71958860981989882291791515610","title":"Identidad musical","caption":"Papelería · Dirección visual","alt":"Identidad musical · Papelería · Dirección visual","width":1600,"height":900,"contain":true},
{"image":"//azabache-producciones.com/cdn/shop/t/6/assets/az-3d12f8a4-portfolio-maylife.webp?v=172233012157936571381791515480","thumb":"//azabache-producciones.com/cdn/shop/t/6/assets/az-55eb7aec-portfolio-maylife-thumb.webp?v=174167875573520754431791515502","title":"Maylife","caption":"Identidad visual · Salud","alt":"Maylife · Identidad visual · Salud","width":1600,"height":900,"contain":true},
{"image":"//azabache-producciones.com/cdn/shop/t/6/assets/az-3de946ce-portfolio-mascotas.webp?v=42529363856705292481791515480","thumb":"//azabache-producciones.com/cdn/shop/t/6/assets/az-277871c9-portfolio-mascotas-thumb.webp?v=96103125454356143501791515466","title":"Accesorios para mascotas","caption":"Marca aplicada · Producto","alt":"Accesorios para mascotas · Marca aplicada · Producto","width":1600,"height":900,"contain":true},
{"image":"//azabache-producciones.com/cdn/shop/t/6/assets/az-8250a4ff-portfolio-menu-gastronomico.webp?v=95473641258448752631791515534","thumb":"//azabache-producciones.com/cdn/shop/t/6/assets/az-be1f3085-portfolio-menu-gastronomico-thumb.webp?v=44409373370854716051791515575","title":"Menú gastronómico","caption":"Diseño editorial · Gastronomía","alt":"Menú gastronómico · Diseño editorial · Gastronomía","width":1600,"height":900,"contain":true},
{"image":"//azabache-producciones.com/cdn/shop/t/6/assets/az-02778a98-portfolio-zengreen.webp?v=63872081419172485051791515438","thumb":"//azabache-producciones.com/cdn/shop/t/6/assets/az-2b78e174-portfolio-zengreen-thumb.webp?v=20576524148563616111791515469","title":"ZenGreen","caption":"Identidad visual · Papelería","alt":"ZenGreen · Identidad visual · Papelería","width":1600,"height":900,"contain":true},
{"image":"//azabache-producciones.com/cdn/shop/t/6/assets/az-d93f592e-portfolio-gonso.webp?v=53578428467515262751791515589","thumb":"//azabache-producciones.com/cdn/shop/t/6/assets/az-d3ab0ca1-portfolio-gonso-thumb.webp?v=165922296175810252591791515586","title":"Tortillería Gonso","caption":"Packaging · Gastronomía","alt":"Tortillería Gonso · Packaging · Gastronomía","width":1600,"height":900,"contain":true},
{"image":"//azabache-producciones.com/cdn/shop/t/6/assets/az-d8fdf32b-portfolio-tacon.webp?v=100135753496305692991791515589","thumb":"//azabache-producciones.com/cdn/shop/t/6/assets/az-43fc4ff9-portfolio-tacon-thumb.webp?v=141641384356903745271791515486","title":"La Pinta del Tacón","caption":"Papelería · Gastronomía","alt":"La Pinta del Tacón · Papelería · Gastronomía","width":1600,"height":900,"contain":true},
{"image":"//azabache-producciones.com/cdn/shop/t/6/assets/az-10116b5c-portfolio-logos-01.webp?v=88535648419909816801791515451","thumb":"//azabache-producciones.com/cdn/shop/t/6/assets/az-b998d671-portfolio-logos-01-thumb.webp?v=73646469276912871731791515571","title":"Logofolio / 01","caption":"Selección de identidades","alt":"Logofolio / 01 · Selección de identidades","width":1600,"height":900,"contain":true},
{"image":"//azabache-producciones.com/cdn/shop/t/6/assets/az-6168dd3d-portfolio-logos-02.webp?v=38071137981786034831791515511","thumb":"//azabache-producciones.com/cdn/shop/t/6/assets/az-8ae494a1-portfolio-logos-02-thumb.webp?v=72146019303572186751791515538","title":"Logofolio / 02","caption":"Selección de identidades","alt":"Logofolio / 02 · Selección de identidades","width":1600,"height":900,"contain":true},
{"image":"//azabache-producciones.com/cdn/shop/t/6/assets/az-b257d5d7-portfolio-logos-03.webp?v=169029374714763385951791515565","thumb":"//azabache-producciones.com/cdn/shop/t/6/assets/az-040eaf44-portfolio-logos-03-thumb.webp?v=122077904723553116481791515439","title":"Logofolio / 03","caption":"Selección de identidades","alt":"Logofolio / 03 · Selección de identidades","width":1600,"height":900,"contain":true},
{"image":"//azabache-producciones.com/cdn/shop/t/6/assets/az-4a3e7ab8-portfolio-logos-04.webp?v=158632013620953868921791515494","thumb":"//azabache-producciones.com/cdn/shop/t/6/assets/az-c52cc973-portfolio-logos-04-thumb.webp?v=175497553445392563601791515579","title":"Logofolio / 04","caption":"Selección de identidades","alt":"Logofolio / 04 · Selección de identidades","width":1600,"height":900,"contain":true},
{"image":"//azabache-producciones.com/cdn/shop/t/6/assets/az-c4a9d677-portfolio-koi-social.webp?v=165801327575838248141791515578","thumb":"//azabache-producciones.com/cdn/shop/t/6/assets/az-bb13b025-portfolio-koi-social-thumb.webp?v=91582842495339657401791515574","title":"Sushi Koi","caption":"Identidad visual · Redes sociales","alt":"Sushi Koi · Identidad visual · Redes sociales","width":838,"height":524,"contain":true},
{"image":"//azabache-producciones.com/cdn/shop/t/6/assets/az-a790b91c-portfolio-koi-uniforme.webp?v=103880371053461284551791515556","thumb":"//azabache-producciones.com/cdn/shop/t/6/assets/az-27f4cf08-portfolio-koi-uniforme-thumb.webp?v=89690505444531852031791515467","title":"Sushi Koi","caption":"Marca aplicada · Uniformes","alt":"Sushi Koi · Marca aplicada · Uniformes","width":830,"height":830,"contain":true},
  {
    "image": "//azabache-producciones.com/cdn/shop/t/6/assets/az-59f55fd6-branding-02.jpg?v=125283765220028259201791515506",
    "title": "La Pinta del Tacón",
    "caption": "Identidad visual · Aplicaciones",
    "alt": "Identidad de La Pinta del Tacón en papelería, vaso y material promocional",
    "contain": true
  },
  {
    "image": "//azabache-producciones.com/cdn/shop/t/6/assets/az-6f18d72d-portfolio-122220219-38-2.png?v=131408479466284235831791515520",
    "title": "Vengali",
    "caption": "Identidad visual",
    "description": "Composición de marca con logotipo, lema e imagen tratada en azul y magenta.",
    "alt": "Composición de marca con logotipo, lema e imagen tratada en azul y magenta.",
    "width": 1400,
    "height": 900,
    "contain": true
  },
  {
    "image": "//azabache-producciones.com/cdn/shop/t/6/assets/az-6aec7ef9-portfolio-122222201-3-0.png?v=148328761822883983321791515517",
    "title": "Casa Blanca",
    "caption": "Tarjetas",
    "description": "Presentación de tarjetas de visita con la identidad visual de Casa Blanca.",
    "alt": "Presentación de tarjetas de visita con la identidad visual de Casa Blanca.",
    "width": 1846,
    "height": 1607,
    "contain": true
  },
  {
    "image": "//azabache-producciones.com/cdn/shop/t/6/assets/az-4478e325-portfolio-122220219-12-0.png?v=36166826620046442401791515487",
    "title": "Tepuy",
    "caption": "Identidad visual",
    "description": "Portada del manual de marca con símbolo, logotipo y patrón en tonos dorados.",
    "alt": "Portada del manual de marca con símbolo, logotipo y patrón en tonos dorados.",
    "width": 1400,
    "height": 900,
    "contain": true
  },
  {
    "image": "//azabache-producciones.com/cdn/shop/t/6/assets/az-b7b8e184-portfolio-122220219-33-2.png?v=118954817019725234141791515570",
    "title": "Kfe",
    "caption": "Identidad visual",
    "description": "Composición fotográfica de café con el logotipo de Kfe.",
    "alt": "Composición fotográfica de café con el logotipo de Kfe.",
    "width": 792,
    "height": 612,
    "contain": true
  },
  {
    "image": "//azabache-producciones.com/cdn/shop/t/6/assets/az-39312790-portfolio-122222201-6-0.jpg?v=177959405271611647671791515478",
    "title": "Adictos Sabores",
    "caption": "Tarjetas",
    "description": "Presentación de tarjetas de visita con logotipo y patrón de ilustraciones gastronómicas.",
    "alt": "Presentación de tarjetas de visita con logotipo y patrón de ilustraciones gastronómicas.",
    "width": 3000,
    "height": 2000,
    "contain": true
  },
  {
    "image": "//azabache-producciones.com/cdn/shop/t/6/assets/az-7e04332e-portfolio-122220219-9-3.png?v=167078525957022779201791515531",
    "title": "Missprendas",
    "caption": "Etiquetas",
    "description": "Aplicación de la identidad en etiquetas colgantes y etiquetas para prendas de vestir.",
    "alt": "Aplicación de la identidad en etiquetas colgantes y etiquetas para prendas de vestir.",
    "width": 791,
    "height": 612,
    "contain": true
  },
  {
    "image": "//azabache-producciones.com/cdn/shop/t/6/assets/az-e2e33fb2-portfolio-122220219-15-0.png?v=181762464073402117271791515597",
    "title": "Tepuy",
    "caption": "Papelería",
    "description": "Aplicación de la marca en diseños de factura.",
    "alt": "Aplicación de la marca en diseños de factura.",
    "width": 1400,
    "height": 900,
    "contain": true
  },
  {
    "image": "//azabache-producciones.com/cdn/shop/t/6/assets/az-834719a4-portfolio-122220219-16-0.png?v=60338594283623029081791515535",
    "title": "Tío Pepe Mecánica",
    "caption": "Identidad visual",
    "description": "Presentación del logotipo ilustrado en la portada del manual de marca.",
    "alt": "Presentación del logotipo ilustrado en la portada del manual de marca.",
    "width": 1400,
    "height": 900,
    "contain": true
  },
  {
    "image": "//azabache-producciones.com/cdn/shop/t/6/assets/az-b621fe3b-portfolio-122220219-24-0.png?v=69387624194981296461791515568",
    "title": "In2 Sports",
    "caption": "Identidad visual",
    "description": "Portada del manual de marca con logotipo deportivo y recursos gráficos en azul y naranja.",
    "alt": "Portada del manual de marca con logotipo deportivo y recursos gráficos en azul y naranja.",
    "width": 1400,
    "height": 900,
    "contain": true
  },
  {
    "image": "//azabache-producciones.com/cdn/shop/t/6/assets/az-af604a6e-portfolio-122220219-28-0.png?v=184402181951488464041791515562",
    "title": "In2 Sports",
    "caption": "Vestuario",
    "description": "Aplicación del logotipo en camisetas para niños y niñas.",
    "alt": "Aplicación del logotipo en camisetas para niños y niñas.",
    "width": 1400,
    "height": 900,
    "contain": true
  },
  {
    "image": "//azabache-producciones.com/cdn/shop/t/6/assets/az-dd05a070-portfolio-122220219-33-0.png?v=92341232157119683971791515594",
    "title": "Kfe",
    "caption": "Delantal",
    "description": "Aplicación del logotipo y los colores de marca en un delantal.",
    "alt": "Aplicación del logotipo y los colores de marca en un delantal.",
    "width": 792,
    "height": 612,
    "contain": true
  },
  {
    "image": "//azabache-producciones.com/cdn/shop/t/6/assets/az-5735bed2-portfolio-122220219-38-1.png?v=96842521454704349071791515504",
    "title": "Vengali",
    "caption": "Uniforme",
    "description": "Aplicación de la identidad visual en una camisa de uniforme.",
    "alt": "Aplicación de la identidad visual en una camisa de uniforme.",
    "width": 1400,
    "height": 900,
    "contain": true
  },
  {
    "image": "//azabache-producciones.com/cdn/shop/t/6/assets/az-71df0dd0-portfolio-122220219-43-0.png?v=98474733159041580601791515522",
    "title": "Rincón del Tíbet",
    "caption": "Identidad visual",
    "description": "Portada del manual de marca con símbolo de loto y recursos gráficos dorados.",
    "alt": "Portada del manual de marca con símbolo de loto y recursos gráficos dorados.",
    "width": 792,
    "height": 612,
    "contain": true
  },
  {
    "image": "//azabache-producciones.com/cdn/shop/t/6/assets/az-89599d8b-portfolio-122220219-50-0.png?v=53448265429254884191791515538",
    "title": "Rincón del Tíbet",
    "caption": "Taza",
    "description": "Aplicación del símbolo y el patrón de marca en una taza.",
    "alt": "Aplicación del símbolo y el patrón de marca en una taza.",
    "width": 792,
    "height": 612,
    "contain": true
  },
  {
    "image": "//azabache-producciones.com/cdn/shop/t/6/assets/az-62b04de0-portfolio-122220219-58-0.png?v=59902934753797265281791515512",
    "title": "Tera Store",
    "caption": "Identidad visual",
    "description": "Logotipo de Tera sobre un patrón gráfico inspirado en circuitos.",
    "alt": "Logotipo de Tera sobre un patrón gráfico inspirado en circuitos.",
    "width": 1366,
    "height": 768,
    "contain": true
  },
  {
    "image": "//azabache-producciones.com/cdn/shop/t/6/assets/az-4783ebdc-portfolio-122222201-5-0.jpeg?v=30277750435553082911791515491",
    "title": "Tera Store",
    "caption": "Tarjetas",
    "description": "Aplicación de la marca en tarjetas de visita con formas geométricas y colores contrastantes.",
    "alt": "Aplicación de la marca en tarjetas de visita con formas geométricas y colores contrastantes.",
    "width": 1258,
    "height": 1258,
    "contain": true
  },
  {
    "image": "//azabache-producciones.com/cdn/shop/t/6/assets/az-b441b6c3-portfolio-122220219-63-0.png?v=126992227100351855851791515566",
    "title": "Adictos Sabores",
    "caption": "Logotipo",
    "description": "Presentación del imagotipo de Adictos Sabores y su lema «Prueba lo irresistible».",
    "alt": "Presentación del imagotipo de Adictos Sabores y su lema «Prueba lo irresistible».",
    "width": 2200,
    "height": 1700,
    "contain": true
  },
  {
    "image": "//azabache-producciones.com/cdn/shop/t/6/assets/az-3eb15851-portfolio-122220219-66-0.png?v=103362007089400381151791515481",
    "title": "Adictos Sabores",
    "caption": "Uniforme de cocina",
    "description": "Aplicación de la marca en chaqueta de cocina y delantales.",
    "alt": "Aplicación de la marca en chaqueta de cocina y delantales.",
    "width": 2200,
    "height": 1700,
    "contain": true
  },
  {
    "image": "//azabache-producciones.com/cdn/shop/t/6/assets/az-96460feb-portfolio-122220219-4-1.png?v=84826411194288598631791515547",
    "title": "Óptica Héctor Lazoa",
    "caption": "Rótulos",
    "description": "Aplicación del logotipo y los recursos gráficos de la marca en rótulos de fachada.",
    "alt": "Aplicación del logotipo y los recursos gráficos de la marca en rótulos de fachada.",
    "width": 1400,
    "height": 900,
    "contain": true
  },
  {
    "image": "//azabache-producciones.com/cdn/shop/t/6/assets/az-413b4663-portfolio-122220219-57-2.png?v=23430125419501486081791515484",
    "title": "Casa Blanca",
    "caption": "Papelería",
    "description": "Aplicación de la identidad visual en hojas membretadas.",
    "alt": "Aplicación de la identidad visual en hojas membretadas.",
    "width": 793,
    "height": 613,
    "contain": true
  },
  {
    "image": "//azabache-producciones.com/cdn/shop/t/6/assets/az-7867cafa-branding-01.jpg?v=161393205387587713081791515527",
    "title": "Identidades con carácter",
    "caption": "Selección de logos",
    "alt": "Selección de logos del portafolio de Azabache Producciones",
    "contain": true
  }
];
let visibleProjects=6, currentProject=0;
const portfolioGrid=document.getElementById('portfolio-grid'),portfolioDialog=document.getElementById('portfolio-dialog');
const escapePortfolioText=value=>String(value).replace(/[&<>"']/g,char=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
function renderPortfolio(){
  portfolioGrid.innerHTML=portfolio.slice(0,visibleProjects).map((project,index)=>`<figure><button class="work-image ${project.contain?'logo-sheet':''}" data-project="${index}" aria-label="Ampliar: ${escapePortfolioText(project.title)}"><img src="${project.image}" alt="${escapePortfolioText(project.alt)}" loading="lazy" width="${project.width||960}" height="${project.height||540}"><span class="work-open">Ver proyecto <span aria-hidden="true">↗</span></span></button><figcaption><div><h3>${escapePortfolioText(project.title)}</h3><p>${escapePortfolioText(project.caption)}</p></div><span aria-hidden="true">↗</span></figcaption></figure>`).join('');
  const shown=Math.min(visibleProjects,portfolio.length);
  document.getElementById('portfolio-count').textContent=shown+' de '+portfolio.length+' imágenes';
  document.getElementById('more-projects').hidden=shown===portfolio.length;localize(portfolioGrid);localize(document.getElementById('portfolio-count'));
}
function showProject(index){
  currentProject=(index+portfolio.length)%portfolio.length;
  const project=portfolio[currentProject],img=document.getElementById('portfolio-image');
  img.src=project.image;img.alt=project.alt;
  document.getElementById('portfolio-position').textContent=String(currentProject+1).padStart(2,'0')+' / '+String(portfolio.length).padStart(2,'0');
  document.getElementById('portfolio-title').textContent=project.title;
  document.getElementById('portfolio-caption').textContent=project.description||project.caption;
  localize(portfolioDialog);if(!portfolioDialog.open)portfolioDialog.showModal();
}
portfolioGrid.addEventListener('click',event=>{const button=event.target.closest('[data-project]');if(button)showProject(Number(button.dataset.project))});
document.getElementById('more-projects').addEventListener('click',()=>{const firstNew=visibleProjects;visibleProjects+=6;renderPortfolio();portfolioGrid.querySelector('[data-project="'+firstNew+'"]').focus()});
document.getElementById('previous-project').addEventListener('click',()=>showProject(currentProject-1));
document.getElementById('next-project').addEventListener('click',()=>showProject(currentProject+1));
portfolioDialog.querySelector('.dialog-close').addEventListener('click',()=>portfolioDialog.close());
portfolioDialog.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'){event.preventDefault();showProject(currentProject-1)}if(event.key==='ArrowRight'){event.preventDefault();showProject(currentProject+1)}});
portfolioDialog.addEventListener('click',event=>{if(event.target===portfolioDialog){const r=portfolioDialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)portfolioDialog.close()}});
renderPortfolio();
